import * as React from 'react';

import * as Edge from '../../../core';
import Error from '../../../components/global/error';
import Input from '../../../components/global/input';

export interface ChangePromoCodeProps {
	changePromoCode: (newPromoCode: string) => Promise<void>;
	currentPromoCode?: string;
}

interface ChangePromoCodeState {
	error?: Edge.Models.EdgeError;
	newPromoCode: string;
}

export class ChangePromoCode extends React.PureComponent<ChangePromoCodeProps, ChangePromoCodeState> {
	constructor(props: ChangePromoCodeProps) {
		super(props);
		this.state = {
			newPromoCode: this.props.currentPromoCode || '',
		};
	}
	public render(): JSX.Element {
		const { newPromoCode, error } = this.state;

		return (
			<>
				<p>Change this Event Team's Promo Code.</p>
				<Input
					ref="editPromoCodeInput"
					type="text"
					maxLength={20}
					value={newPromoCode}
					onChange={this.changePromoCode}
				/>
				{error && <Error>{Edge.API.getErrorMessage(error)}</Error>}
				<Input onClick={this.submitPromoCode} value="Save" type="submit" />
			</>
		);
	}

	private submitPromoCode = async () => {
		try {
			await this.props.changePromoCode(this.state.newPromoCode);
		} catch (e) {
			this.setState({ error: e as Edge.Models.EdgeError });
		}
	};

	private changePromoCode = (e: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({ newPromoCode: e.target.value.toUpperCase() });
	};
}

export default ChangePromoCode;
